<div class="nuestro-trabajo mt-5 pt-5 pb-5">

  <div class="titulo">
    <app-titulo-descripcion titulo={{titulo}} descripcion={{descripcion}}></app-titulo-descripcion>
  </div>

  <div class="trabajo m-auto pt-5">
    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-home icono mr-2"></i>
      <strong class="text-dark">{{subtituloA}} </strong>
    </h2>

    <app-carta-img-arrb *ngFor="let datos of datosTrabajo" imagen={{datos.imagen}} descripcion={{datos.descripcion}}>
    </app-carta-img-arrb>
  </div>

  <div class="equipo m-auto pt-5">
    <h2 class="subtitulo-b text-center mb-4">
      <i class="fas fa-users icono mr-2"></i>
      <strong class="text-dark">{{subtituloB}}</strong>
    </h2>

    <div class="texto m-3 text-center">
      <p>{{equipoDescripcion}}</p>
    </div>



    <div class="voluntarios m-auto pt-5">
      <h2 class="subtitulo-b text-center mb-4">
        <i class="fas fa-hands-helping icono mr-2"></i>
        <strong class="text-dark">{{subtituloC}}</strong>
      </h2>

      <div class="carrusel row justify-content-center">
        <carousel height={{scrHeight}} width={{scrWidth}} cellWidth={{scrWidth}} autoplay="true" autoplayInterval="5000"
          loop="true" dots="true" [images]="imagenes">
        </carousel>
      </div>
    </div>
  </div>

</div>
